<template>
    <div class="tp-gen">
        <div class="h-panel-bar">
            <span class="h-panel-title">生成凭证预览</span>
            <span class="bar-tools">
                <Checkbox v-model="merge" @change="build">合并凭证</Checkbox>
                <template v-if="merge">
                    <Checkbox v-model="mergeType" :datas="mergeOptions" @change="build" class="inline-block margin-left"/>
                </template>
                <Button size="s" color="primary" :loading="loading" @click="doGenerate" :disabled="!vouchers.length">生成</Button>
            </span>
        </div>
        <div class="tp-gen-body">
            <div v-if="loading" class="text-center" style="padding:40px">凭证构建中...</div>
            <div v-else-if="error" class="red-color" style="padding:20px">{{error}}</div>
            <div v-else-if="!vouchers.length" class="text-center dark2-color" style="padding:40px">暂无可生成的凭证</div>
            <div v-for="(v, i) in vouchers" :key="i" class="tp-voucher">
                <div class="tp-voucher-head">
                    <span>凭证字：{{v.word}}</span>
                    <span class="margin-left">日期：{{v.voucherDate}}</span>
                    <span class="margin-left">摘要：{{v.remark}}</span>
                    <span class="margin-left">共 {{(v.details || []).length}} 行</span>
                </div>
                <table class="grid">
                    <thead>
                    <tr>
                        <th style="width:220px">科目</th>
                        <th>摘要</th>
                        <th style="width:140px">辅助核算</th>
                        <th style="width:120px">借方金额</th>
                        <th style="width:120px">贷方金额</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(d, k) in v.details" :key="k">
                        <td>{{d.subjectCode}} {{d.subjectName}}</td>
                        <td>{{d.summary}}</td>
                        <td>{{d.auxiliaryTitle}}</td>
                        <td align="right">{{d.debitAmount | numFormat}}</td>
                        <td align="right">{{d.creditAmount | numFormat}}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">合计</td>
                        <td align="right">{{sum(v, 'debitAmount') | numFormat}}</td>
                        <td align="right">{{sum(v, 'creditAmount') | numFormat}}</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="h-panel-bar text-right">
            <Button @click="$emit('close')">取消</Button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TripartiteGenerateVoucher",
        props: {
            definition: Object,
            records: Array
        },
        data() {
            return {
                merge: false,
                mergeType: ['mergeDebit', 'mergeCredit'],
                mergeOptions: [
                    {title: '合并相同借方', key: 'mergeDebit'},
                    {title: '合并相同贷方', key: 'mergeCredit'}
                ],
                vouchers: [],
                loading: false,
                error: ''
            };
        },
        methods: {
            build() {
                this.loading = true;
                this.error = '';
                let ids = (this.records || []).map(r => r.id);
                let p = {
                    ids: ids,
                    preview: true,
                    merge: this.merge,
                    mergeType: (this.mergeType || []).join(',')
                };
                this.$api.tripartite.data.generateVoucher(this.definition.id, p).then(({data}) => {
                    this.vouchers = data || [];
                }).catch(e => {
                    this.error = e && e.message ? e.message : '凭证生成失败';
                    this.vouchers = [];
                }).finally(() => {
                    this.loading = false;
                });
            },
            doGenerate() {
                this.loading = true;
                let ids = (this.records || []).map(r => r.id);
                let p = {
                    ids: ids,
                    preview: false,
                    merge: this.merge,
                    mergeType: (this.mergeType || []).join(',')
                };
                this.$api.tripartite.data.generateVoucher(this.definition.id, p).then(({data}) => {
                    let failed = (data && data.failedList) || [];
                    if (failed.length) {
                        this.$Message(`部分记录凭证生成失败（${failed.length} 条），请检查`);
                    } else {
                        this.$Message(`生成成功 ${(data && data.successCount) || 0} 张凭证`);
                    }
                    this.$emit('success');
                }).catch(e => {
                    this.error = e && e.message ? e.message : '凭证生成失败';
                    this.loading = false;
                });
            },
            sum(v, key) {
                let t = 0;
                (v.details || []).forEach(d => {
                    t += parseFloat(d[key] || 0);
                });
                return t;
            }
        },
        mounted() {
            this.build();
        }
    };
</script>

<style lang="less" scoped>
    .tp-gen {
        display: flex;
        flex-direction: column;
        height: 100%;

        .tp-gen-body {
            flex: 1;
            overflow: auto;
            padding: 10px 12px;
        }
    }

    .tp-voucher {
        border: 1px solid @gray2-color;
        margin-bottom: 14px;
    }

    .tp-voucher-head {
        padding: 8px 10px;
        background: @gray4-color;
        font-size: 13px;
    }

    tfoot td {
        font-weight: bold;
        background: @gray4-color;
    }
</style>
